<div class="page">
  <div class="header">
    <div class="title-block">
      <h1 class="title">Expense Approvals</h1>
      <div class="subtitle">
        Review team expenses and manage approvers by {{ isNativeCompanyManager ? 'team' : 'payroll team' }}
      </div>
    </div>
  </div>

  @if (!isInitialCompanyCheckComplete || isTeamsLoading) {
    <section class="page-loading">
      <mat-spinner [diameter]="32"></mat-spinner>
      <span>Loading expense approvals</span>
    </section>
  }

  @if (isInitialCompanyCheckComplete && !isTeamsLoading && !hasCompany) {
    <section class="setup-cta">
      <div class="setup-cta-content">
        <mat-icon>business</mat-icon>
        <div class="setup-cta-copy">
          <h2>{{ isNativeCompanyManager ? 'No employer company available' : 'Create your first company' }}</h2>
          @if (isNativeCompanyManager) {
            <p>Expense Approvals requires an authorized employer company.</p>
          }
          @if (!isNativeCompanyManager) {
            <p>To use Expense Approvals, create a company first in Company &gt; Company.</p>
          }
        </div>
      </div>
      @if (!isNativeCompanyManager) {
        <button mat-raised-button color="primary" type="button" (click)="onGoToCompanyTab()">
          Go to Company
        </button>
      }
    </section>
  }

  @if (isInitialCompanyCheckComplete && !isTeamsLoading && hasCompany && !teams.length) {
    <section class="setup-cta">
      <div class="setup-cta-content">
        <mat-icon>groups</mat-icon>
        <div class="setup-cta-copy">
          <h2>Create your first team</h2>
          <p>Expense approvals are managed at the team level. Create a team first from Teams.</p>
        </div>
      </div>
      <button mat-raised-button color="primary" type="button" (click)="onGoToTeams()">
        Go to Teams
      </button>
    </section>
  }

  @if (isInitialCompanyCheckComplete && !isTeamsLoading && selectedTeam) {
    <section class="approvals-shell">
      <div class="select-row">
        <div class="select-label">Select team:</div>
        <mat-form-field appearance="outline" class="team-select">
          <mat-select [value]="selectedTeamId" (selectionChange)="onSelectedTeamChange($event.value)">
            @for (item of teams; track item) {
              <mat-option [value]="item.id">{{ item.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <mat-tab-group
        class="tabs"
        [selectedIndex]="selectedTabIndex"
        [animationDuration]="'0ms'"
        (selectedIndexChange)="onTabChange($event)"
        >
        <mat-tab label="Transactions">
          <ng-template matTabContent>
            <div class="tab-panel">
              <app-analytics-toapprove [team]="selectedTeam"></app-analytics-toapprove>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Receipts to Approve">
          <ng-template matTabContent>
            <div class="tab-panel">
              <app-analytics-approve [team]="selectedTeam" [filter]="''" [activeTitle]="'Receipts to Approve'"></app-analytics-approve>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Approved Receipts">
          <ng-template matTabContent>
            <div class="tab-panel">
              <app-analytics-approve
                [team]="selectedTeam"
                [filter]="'Reimbursement approved'"
                [activeTitle]="'Approved Receipts'"
              ></app-analytics-approve>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Denied Receipts">
          <ng-template matTabContent>
            <div class="tab-panel">
              <app-analytics-approve
                [team]="selectedTeam"
                [filter]="'Reimbursement denied'"
                [activeTitle]="'Denied Receipts'"
              ></app-analytics-approve>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Reimbursements">
          <ng-template matTabContent>
            <div class="tab-panel">
              <app-analytics-approve
                [team]="selectedTeam"
                [filter]="'Reimbursed'"
                [activeTitle]="'Reimbursements'"
              ></app-analytics-approve>
            </div>
          </ng-template>
        </mat-tab>
        <mat-tab label="Configure Approvers">
          <ng-template matTabContent>
            <div class="tab-panel">
              <app-analytics-configure [team]="selectedTeam"></app-analytics-configure>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </section>
  }
</div>
